<script setup>
    import { router } from '@inertiajs/vue3';
    import JetButton from '@/Jetstream/Button.vue';
    import { ref } from 'vue';

    // includes we need to front end locale magic
    import { useI18n } from 'vue-i18n';
    // Get locale as set in cookie
    let { locale } = useI18n({ useScope: 'global' });

    const props = defineProps({
        toolkit: Object,
        actions: Array,
        loggedInUserId: Number,
        activeToolkits: Array,
        previousToolkits: Array,
        loggedInUser: Object,
    });

    const enabling = ref(false);

    const programme = router.page.props.ziggy.programme;
    const organisation = router.page.props.ziggy.organisation;
    const urlNamePrefix = organisation ? "gi." : "";

    const activeToolkits = props.activeToolkits;
    const previousToolkits = props.previousToolkits;

    const anyToolkits = props.activeToolkits.length > 0 ? true : false;
    const anyPastToolkits = props.previousToolkits.length > 0 ? true : false;

    let team_custom_name = programme.team_custom_name;
    if (team_custom_name) {
        if(team_custom_name.constructor.name != 'Object') {
            team_custom_name = JSON.parse(team_custom_name);
        }
    }

    let default_team_name;

    if (locale.value == 'cy') {
        default_team_name = 'tîm';

    } else  {
        default_team_name = 'team';
    }

    let team_name = default_team_name;

    if (team_custom_name) {
        team_name =  team_custom_name[locale.value] == null ? default_team_name : team_custom_name[locale.value];
    }

    const retractSubmission = (teamToolkitId) => {
        enabling.value = true;
        router.put(route(urlNamePrefix+'toolkit-team.retract'),
        {
            team_toolkit_id: teamToolkitId,
            team_id: props.loggedInUser.current_team.id
        }, {
            onSuccess: page => {
                enabling.value = false;
            },
            onError: (errors) => {
                enabling.value = false;
            },
        });
    }

</script>

<template>
    <div class="dashboard-widget widget previous-toolkits-widget">
        <div class="widget-header flex justify-between">
            <span>{{ $t('dashboard.widgets.previous_toolkits.title') }}</span>
            <span class="material-icons-outlined">construction</span>
        </div>
        <div class="widget-content">
            <p v-if="!anyPastToolkits">{{ $t('toolkit.past.none', { team_name: team_name }) }}</p>

            <div v-if="anyPastToolkits" v-for="(previousToolkit, itemKey) in previousToolkits">
                <a type="button" v-if="organisation" class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25 transition float-right" :href="route(urlNamePrefix+'past-toolkit.view', {programme:programme.slug, organisation:organisation.slug, toolkit:previousToolkit.id})">
                    {{ $t('toolkit.past.view') }}
                </a>

                <a type="button" v-else class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25 transition float-right" :href="route(urlNamePrefix+'past-toolkit.view', {programme:programme.slug, toolkit:previousToolkit.id})">
                    {{ $t('toolkit.past.view') }}
                </a>

                <JetButton type="button" :class="[{ 'opacity-25': enabling }, 'float-right mx-2']" v-if="previousToolkit.retractable" v-on:click="retractSubmission(previousToolkit.teamToolkitId)">
                    {{ $t('toolkit.past.retract') }}
                </JetButton>

                <h3 style="margin-bottom: 10px;">{{previousToolkit.name}} ({{ team_name }})</h3>
                <div class="border border-gray-300 rounded-lg mt-5 p-5">
                    <table class="responsive stripe hover w-full text-left table-collapse">
                        <thead>
                            <tr>
                                <th class="py-2 px-4 w-60">{{ $t('toolkit.past.status') }}</th>
                                <th class="py-2 px-4 w-60">{{ $t('toolkit.past.actions') }}</th>
                                <th class="py-2 px-4">{{ $t('toolkit.past.completed_points') }} </th>
                                <th class="py-2 px-4">{{ $t('toolkit.past.completed_actions') }} </th>
                                <th class="py-2 px-4">{{ $t('toolkit.past.awards') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="py-2 px-4">{{previousToolkit.toolkit_status}}</td>
                                <td class="py-2 px-4">
                                    {{previousToolkit.toolkit_actions}}
                                    <div class="flex flex-row justify-start" v-if="previousToolkit.FIR" style="color: red;">
                                        <span class="material-icons-outlined mr-2">info</span> {{ $t('toolkit.past.action_required') }}
                                    </div>
                                </td>
                                <td class="py-2 px-4">{{previousToolkit.totalCompletedPoints}} {{ $t('toolkit.past.out_of') }} {{previousToolkit.totalPoints}}</td>
                                <td class="py-2 px-4">{{previousToolkit.totalCompletedActions}} {{ $t('toolkit.past.out_of') }} {{previousToolkit.totalActions}}</td>
                                <td class="py-2 px-4">
                                    <div v-if="previousToolkit.completed_awards && previousToolkit.completed_awards.length > 0" v-for="award in previousToolkit.completed_awards" class="completed-award" :style="'background-color: ' +  award.color + ';'">
                                        {{award.name}}
                                    </div>
                                    <div v-else>
                                        {{ $t('toolkit.past.not_applicable') }}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <hr v-if="itemKey + 1 !== previousToolkits.length " class="my-5" />
            </div>
        </div>
    </div>
</template>
